import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconEmbedded = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M9 13L6 15L9 17" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 17L18 15L15 13" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 17L12 15L13 13" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 9H21" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export default IconEmbedded
